import { Input } from "antd";
import { Control, Controller } from "react-hook-form";
import { HTMLInputTypeAttribute, ReactNode } from "react";

interface IProps {
  name: string;
  label: string;
  placeholder: string;
  control: Control<any, any>;
  type: HTMLInputTypeAttribute;
  prefix?: ReactNode;
  disabled?: boolean;
  step?: string | number;
  min?: string | number;
  max?: string | number;
}

export default function LabeledInput({
  name,
  label,
  placeholder,
  control,
  disabled,
  prefix,
  type,
  step,
  min,
  max,
}: IProps) {
  return (
    <Controller
      control={control}
      name={name}
      disabled={disabled}
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <div className="w-full">
          <label
            htmlFor={name}
            className="pl-1"
            style={{ color: "rgba(0,0,0,.7)", fontSize: ".85rem" }}
          >
            {label}
          </label>
          <Input
            prefix={prefix}
            id={name}
            type={type}
            step={step}
            min={min}
            max={max}
            className="h-auto w-full py-2 outline-none"
            {...field}
            placeholder={placeholder}
            status={error ? "error" : undefined}
            disabled={disabled || field.disabled}
          />
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
